<template>
    <Header>
      <div class="headtop">
        <div class="headtop_">
          <div class="wechatbox">
            <div class="wechatbox-img" v-for="(item, index) in ewimg" :key="index">
              <img :src="domainNameH5+'/'+item.picurl" :alt="item.title" width="100%" height="100%">
              <div class="wechatbox-img-big">
                <img :src="domainNameH5+'/'+item.picurl" :alt="item.title" width="100%">
              </div>
            </div>
            <div class="wechatbox-title">金色年华官方微信</div>
          </div>
          <div class="login-box" v-if="getUserId==''">
            <router-link to="/login" target="_blank" class="login-link">登录</router-link>
            <span class="line"></span>
            <router-link to="/register" target="_blank" class="login-link">注册</router-link>
          </div>
          <div class="login-box" v-else>
            <div class="userinfo" @click="memberPage">
              <div class="userimg"></div>
              <div class="username">{{getUser}}</div>
            </div>
            <div class="loginout" @click="loginOut">退出</div>
          </div>
          <div class="headtop-hotline">服务热线：{{config.cfg_hotline}}</div>
          <div class="headtop-btn">
            <a href="http://www.zju-goldenyears.xyz:8080/Admin" target="_blank">金色智云</a>
            <span></span>
            <a href="javascript:;" @click="addFavorite">收藏</a>
          </div>
        </div>
      </div>
      <div class="nav">
        <div class="nav_">
          <router-link to="/home" class="logo" v-if="logo.length>0" :style="'backgroundImage:url(' + domainNameH5 + '/' + logo[0].picurl + ')'"></router-link>
          <div class="nav-list" v-if="nav.length>0">
            <div class="nav-li">
              <div class="nav-li_" :class="[ getActiveMenu == 'home' ? 'active' : '' ]">
                <router-link to="/home" class="nav-li-item">
                  <div class="chname">首页</div>
                  <div class="enname">Home</div>
                </router-link>
              </div>
            </div>
            <div class="nav-li">
              <div class="nav-li_" @mouseenter="showDrop($event)" @mouseleave="hideDrop($event)" :class="[ getActiveMenu == 'homecare' ? 'active' : '' ]">
                <router-link to="/homecare" class="nav-li-item">
                  <div class="chname">{{nav[0]['classname']}}</div>
                  <div class="enname">{{nav[0]['classname_en']}}</div>
                  <span class="icon el-icon-arrow-down"></span>
                </router-link>
                <div class="dropbox type1">
                  <dl v-for="item in homeCare" :key="item.id">
                    <dt :class="[ getActiveSendMenu == item.id ? 'active' : '' ]">
                      <router-link :to="{ path: '/homecare/index', query: { cid: item.id } }">{{item.classname}}</router-link>
                    </dt>
                    <!--<dd><router-link to="">服务1</router-link></dd>
                    <dd><router-link to="">服务1</router-link></dd>
                    <dd><router-link to="">服务1</router-link></dd>
                    <dd><router-link to="">服务1</router-link></dd>
                    <dd><router-link to="">服务1</router-link></dd>
                    <dd><router-link to="">服务1</router-link></dd>-->
                  </dl>
                </div>
              </div>
            </div>
            <div class="nav-li">
              <div class="nav-li_" @mouseenter="showDrop($event)" @mouseleave="hideDrop($event)" :class="[ getActiveMenu == 'mechanism' ? 'active' : '' ]">
                <router-link to="/mechanism" class="nav-li-item">
                  <div class="chname">{{nav[1]['classname']}}</div>
                  <div class="enname">{{nav[1]['classname_en']}}</div>
                  <span class="icon el-icon-arrow-down"></span>
                </router-link>
                <div class="dropbox type1">
                  <dl v-for="item in mechanism" :key="item.id">
                    <dt :class="[ getActiveSendMenu == item.id ? 'active' : '' ]">
                      <router-link :to="{ path: '/mechanism/index', query: { cid: item.id, pid: '' } }">{{item.classname}}</router-link>
                    </dt>
                  </dl>
                </div>
              </div>
            </div>
            <div class="nav-li">
              <div class="nav-li_">
                <router-link to="/publicwelfare" class="nav-li-item">
                  <div class="chname">{{nav[7]['classname']}}</div>
                  <div class="enname">{{nav[7]['classname_en']}}</div>
                </router-link>
              </div>
            </div>
            <div class="nav-li">
              <div class="nav-li_" @mouseenter="showDrop($event)" @mouseleave="hideDrop($event)" :class="[ getActiveMenu == 'about' ? 'active' : '' ]">
                <router-link to="/about" class="nav-li-item">
                  <div class="chname">{{nav[2]['classname']}}</div>
                  <div class="enname">{{nav[2]['classname_en']}}</div>
                  <span class="icon el-icon-arrow-down"></span>
                </router-link>
                <div class="dropbox type2">
                  <div class="dropbox-li" v-for="item in aboutus" :key="item.id" :class="[ getActiveSendMenu == item.id ? 'active' : '' ]">
                    <router-link :to="{ path: '/about', query: { cid: item.id } }">{{item.classname}}</router-link>
                  </div>
                  <div class="dropbox-li" :class="[ getActiveSendMenu == 'publicwelfare' ? 'active' : '' ]">
                    <router-link to="/publicwelfare">公益之窗</router-link>
                  </div>
                  <div class="dropbox-li" :class="[ getActiveSendMenu == 'seniorclass' ? 'active' : '' ]">
                    <router-link to="/seniorclass">长者课堂</router-link>
                  </div>
                </div>
              </div>
            </div>
            <div class="nav-li">
              <div class="nav-li_" @mouseenter="showDrop($event)" @mouseleave="hideDrop($event)" :class="[ getActiveMenu == 'join' ? 'active' : '' ]">
                <router-link to="/join" class="nav-li-item">
                  <div class="chname">{{nav[3]['classname']}}</div>
                  <div class="enname">{{nav[3]['classname_en']}}</div>
                  <span class="icon el-icon-arrow-down"></span>
                </router-link>
                <div class="dropbox type3">
                  <div class="dropbox-li" :class="[ getActiveSendMenu == 'volunteer' ? 'active' : '' ]">
                    <router-link to="/join/volunteer">成为志愿者</router-link>
                  </div>
                  <div class="dropbox-li" :class="[ getActiveSendMenu == 'goldenyears' ? 'active' : '' ]">
                    <router-link to="/join/goldenyears">加入金色年华</router-link>
                  </div>
                  <div class="dropbox-li" :class="[ getActiveSendMenu == 'socialservice' ? 'active' : '' ]">
                    <router-link to="/join/socialservice">社会服务者申请</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Header>
</template>

<script>
import { mapGetters } from 'vuex'
import { getHeaderNavData, getLogoData } from '../../api/getData'
export default {
  name: 'HeaderMain',
  props: {
    ewimg: Array,
    config: Object
  },
  data () {
    return {
      nav: [],
      homeCare: {},
      mechanism: {},
      aboutus: {},
      joinus: {},
      logo: []
    }
  },
  computed: {
    ...mapGetters([
      'getUserId',
      'getUser',
      'getActiveMenu',
      'getActiveSendMenu'
    ])
  },
  created () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      let result = await getHeaderNavData()
      this.nav = result.nav
      this.homeCare = result.home_care
      this.mechanism = result.mechanism
      this.aboutus = result.aboutus
      this.joinus = result.joinus

      let postdata = { id: 1 }
      let logoResult = await getLogoData(postdata)
      this.logo = logoResult.logo
    },
    memberPage () {
      this.$router.push({ path: '/member' })
    },
    showDrop (elem) {
      window.$('.dropbox').stop().slideUp(500)
      window.$(elem.target).find('.dropbox').stop().slideDown(500)
    },
    hideDrop (elem) {
      window.$(elem.target).find('.dropbox').stop().slideUp(500)
    },
    loginOut () {
      let path = this.$route.path
      let pathArr = path.split('/')
      this.$store.dispatch('LogOut').then(() => {
        if (pathArr[1] === 'member' || pathArr[1] === 'attention') {
          this.$router.push({
            path: '/'
          })
        }
      }).catch(() => {})
    },
    addFavorite () {
      try {
        window.external.addFavorite(this.$route.fullPath, '金色年华')
      } catch (e) {
        try {
          window.sidebar.addPanel('金色年华', this.$route.fullPath, '')
        } catch (e) {
          alert('加入收藏失败，请使用Ctrl+D进行添加')
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
  .headtop{
    height: 68px;
    background-color: #ec6420;
  }
  .headtop_{
    width: 1632px;
    height: 100%;
    padding: 11px 26px 12px 14px;
    margin: auto;
    .wechatbox{
      float: left;
      .wechatbox-img{
        position: relative;
        float: left;
        width: 45px;
        height: 45px;
        margin-left: 12px;
        background-color: #ffffff;
        .wechatbox-img-big{
          position: absolute;
          top: 0;
          left: 0;
          z-index: 100;
          width: 200px;
          height: 200px;
          display: none;
        }
        &:hover{
          .wechatbox-img-big{
            display: block;
          }
        }
      }
      .wechatbox-title{
        float: left;
        padding: 0 7px;
        font-size: 24px;
        line-height: 45px;
        color: #fefefe;
      }
    }
    .login-box{
      float: right;
      .userinfo{
        float: left;
        cursor: pointer;
        .userimg{
          float: left;
          width: 40px;
          height: 40px;
          margin-right: 20px;
          border-radius: 50%;
          background-color: #ffffff;
          background-image: url("../../assets/images/icons.png");
          background-size: 240px auto;
          background-position: -178px -225px;
        }
        .username{
          float: left;
          margin-right: 35px;
          font-size: 18px;
          line-height: 45px;
          color: #ffffff;
        }
      }
      .loginout{
        float: left;
        font-size: 24px;
        line-height: 45px;
        color: #ffffff;
        cursor: pointer;
      }
      .login-link{
        float: left;
        font-size: 24px;
        line-height: 45px;
        color: #ffffff;
        cursor: pointer;
      }
      .line{
        float: left;
        width: 2px;
        height: 24px;
        margin: 11px 8px 0;
        background-color: #ffffff;
      }
    }
    .headtop-hotline{
      float: right;
      margin-right: 70px;
      font-size: 24px;
      line-height: 45px;
      color: #ffffff;
      font-weight: 400;
    }
    .headtop-btn{
      float: right;
      margin-right: 35px;
      padding: 4px 0 3px;
      a{
        float: left;
        width: 128px;
        height: 38px;
        border: 1px solid #ffffff;
        border-radius: 20px;
        font-size: 18px;
        line-height: 36px;
        text-align: center;
        color: #ffffff;
        transition: all 0.5s ease 0s;
        &:hover{
          background-color: #ffffff;
          color: #ec6420;
        }
      }
      span{
        float: left;
        width: 2px;
        height: 30px;
        background-color: #ffffff;
        margin: 3px 16px;
      }
    }
  }
  .nav{
    height: 80px;
    background-color: #f7f7f7;
  }
  .nav_{
    .headtop_;
    padding: 0 0 0 50px;
    .logo{
      float: left;
      width: 76px;
      height: 80px;
      background-repeat: no-repeat;
      background-position: center;
    }
    .nav-list{
      height: 100%;
      padding: 11px 0 11px 76px;
    }
  }
  .nav-li{
    float: left;
    width: 16.66%;
    height: 58px;
    padding: 0 26px;
    .nav-li_{
      position: relative;
      width: 100%;
      height: 100%;
      background-color: #ffffff;
      border-radius: 35px;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
      cursor: pointer;
      .nav-li-item{
        position: relative;
        display: block;
        width: 100%;
        height: 100%;
        padding: 4px 0;
        border-radius: 35px;
        color: #e8621f;
        transition: all 0.5s ease 0s;
        .chname{
          font-size: 30px;
          line-height: 30px;
          text-align: center;
          font-weight: bold;
        }
        .enname{
          font-size: 14px;
          line-height: 20px;
          text-align: center;
        }
        .icon{
          position: absolute;
          right: 14px;
          top: 50%;
          margin-top: -10px;
          font-size: 20px;
        }
      }
      &:hover .nav-li-item{
        color: #ffffff;
        background-color: #ec6420;
      }
      &.active .nav-li-item{
        color: #ffffff;
        background-color: #ec6420;
      }
      .dropbox{
        display: none;
        position: absolute;
        top: 66px;
        left: 0;
        z-index: 10;
        background-color: #e0e6fd;
        text-align: left;
        font-weight: normal;
        &.type1{
          width: 730px;
          padding: 28px 0 24px 50px;
        }
        &.type2{
          width: 245px;
          padding: 10px 0;
        }
        &.type3{
          width: 215px;
          padding: 10px 0;
        }
        dl{
          float: left;
          width: 135px;
          dt{
            margin-bottom: 2px;
            font-size: 18px;
            line-height: 34px;
            color: #333333;
            a{
              color: #333333;
            }
            &:hover a{
              color: #eb6420;
            }
            &.active a{
              color: #eb6420;
            }
          }
          dd{
            font-size: 16px;
            line-height: 35px;
            a{
              color: #666666;
              &:hover{
                color: #e3601f;
              }
            }
          }
        }
        .dropbox-li{
          font-size: 18px;
          line-height: 42px;
          a{
            display: block;
            padding: 0 0 0 30px;
            color: #333333;
            &:hover{
              color: #e3601f;
            }
          }
          &.active a{
            color: #eb6420;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1638px){
    .headtop_{
      width: 100%;
    }
    .nav_{
      .headtop_;
    }
    .nav-li{
      padding: 0 20px;
    }
  }
  @media screen and (max-width: 1500px){
    .nav-li{
      padding: 0 15px;
      .nav-li_{
        .nav-li-item{
          .chname{
            font-size: 26px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1350px){
    .nav-li{
      padding: 0 10px;
      .nav-li_{
        .nav-li-item{
          .chname{
            font-size: 26px;
          }
          .enname{
            font-size: 12px;
          }
          .icon{
            right: 6px;
          }
        }
      }
    }
  }
  @media screen and (max-width: 1300px){
    .headtop_{
      .wechatbox{
        .wechatbox-title{
          display: none;
        }
      }
    }
  }
</style>
